/**
 * 访问令牌的存放位置：**只放内存**（模块级变量），不进 localStorage。
 *
 * 理由：刷新令牌在 HttpOnly Cookie 里（JS 读不到），accessToken 即使被 XSS 拿到，
 * 也只在 15 分钟内有效且刷新会换新；放进 localStorage 反而会长期留存、扩大 XSS 影响面。
 * 代价是刷新页面后需要一次 `/api/auth/refresh` 才能恢复登录态 —— 由 authStore.bootstrap 完成。
 */
let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}
